import type { ComponentLoaderType } from '@grafikr/components';
import { isbot } from 'isbot';

import regions from 'framework/regions';

const AUTO_OPEN_DELAY_MS = 5000;

const Loader: ComponentLoaderType = (_, load) => {
  let cancelled = false;
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  (async () => {
    if (isbot(navigator.userAgent)) {
      return;
    }

    const getCurrentSite = regions.getCurrentSite();
    const [shouldShowPrompt, getIntendedSite] = await Promise.all([
      regions.shouldShowPrompt(),
      regions.getIntendedSite(),
    ]);

    if (shouldShowPrompt && getCurrentSite !== getIntendedSite) {
      timeoutId = setTimeout(async () => {
        if (cancelled) {
          return;
        }

        const intendedSite = await regions.getIntendedSite();

        if (cancelled) {
          return;
        }

        if (regions.getCurrentSite() !== intendedSite) {
          load();
        }
      }, AUTO_OPEN_DELAY_MS);
    }
  })();

  return () => {
    cancelled = true;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };
};

export default Loader;
